import { Pie } from "react-chartjs-2";

const RolesPieChart = ({ roles }) => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return <p>No data to display</p>;
  }

  const data = {
    labels: roles.map((r) => r.role),
    datasets: [
      {
        data: roles.map((r) => r.count),
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
          "#FF9F40",
        ],
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
    },
  };

  return <Pie data={data} options={options} />;
};

export default RolesPieChart;
